var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.itemSocial.Link.url != '')?_c('div',{staticClass:"item-social"},[_c('a',{attrs:{"href":_vm.itemSocial.Link.url}},[_c('p',{staticClass:"item-social__link"},[_vm._v(_vm._s(_vm.itemSocial.type))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }